"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeModificationRequestIssueComment = void 0;
// FIXME: fromJSON版があるので削除できる
const immutable_1 = require("immutable");
const luxon_1 = require("luxon");
const ModificationRequest_1 = require("../entity/ModificationRequest");
const user_1 = require("./user");
const createSomeModificationRequestIssueComment = ({ id = '12345', body = 'Modification Request Issue Name', user = user_1.createSomeDirectorUser(), assetIds = immutable_1.List(['123', '456', '789']), } = {}) => new ModificationRequest_1.ModificationRequestIssueComment({
    id,
    body,
    user,
    assetIds,
    createdAt: luxon_1.DateTime.fromMillis(0, { zone: 'utc' }),
});
exports.createSomeModificationRequestIssueComment = createSomeModificationRequestIssueComment;
